export const numberWithCommas = (number) => {
    const numericValue = parseFloat(number); // Convert to a number
    return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};